/**
 * Landing — public marketing page at juuniai.com/
 *
 * Shown to unauthenticated visitors via ProtectedRoute's anon-at-root
 * branch. Authenticated users are redirected to their role-appropriate
 * dashboard before they ever see this.
 *
 * Implementation: full-viewport iframe pointing at `/landing.html` (the
 * Claude Design handoff, shipped as a static asset in public/).
 *
 * Why iframe instead of porting the HTML into React:
 *   - The landing is ~1,150 lines of self-contained HTML + inline CSS +
 *     inline JS, with a hand-tuned SVG clock, scroll-synced kanji
 *     backgrounds, and five chapter diagrams. Porting into React would
 *     require babysitting every animation and risk subtle drift from the
 *     design tool preview the user authored it in.
 *   - Iframe preserves pixel-perfect fidelity with claude.ai/design.
 *   - `public/landing.html` has `<base target="_top">` in its head, so
 *     the nav "Sign in" link (href="/login") and the finale "Request
 *     access" CTAs (href="/request-access") navigate the PARENT window —
 *     they land on the SPA's routes, not inside the iframe.
 *
 * Why this is mounted via ProtectedRoute at `/` instead of a Vercel
 * rewrite to /landing.html directly:
 *   - Vercel's filesystem routing serves `dist/index.html` (the SPA
 *     entry) for `/` BEFORE evaluating rewrites in vercel.json, so
 *     `{"source": "/", "destination": "/landing.html"}` doesn't fire.
 *     Mounting the iframe at the SPA's `/` route sidesteps that — React
 *     Router owns `/`, this component runs, and then the iframe loads
 *     /landing.html as a static asset.
 */

export default function Landing() {
  return (
    <iframe
      src="/landing.html"
      title="Juuni — the ops layer for AI data"
      // 100vw / 100vh because the landing relies on position:fixed for
      // nav, clock stage, rail, and kanji backgrounds — it needs the
      // full viewport as its coordinate space. border:none + margin:0
      // keep the iframe visually invisible.
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100vw',
        height: '100vh',
        border: 'none',
        margin: 0,
        display: 'block',
      }}
    />
  );
}
